import React from 'react'
import Footer from '../../components/Footer'

const Opportunities = () => {
 return (
    <>
      <style>
        {`
          @keyframes typewriter {
            0% {
              clip-path: inset(0 100% 0 0);
            }
            80% {
              clip-path: inset(0 0% 0 0);
            }
            100% {
              clip-path: inset(0 0% 0 0);
            }
          }

          .typewriter {
            display: inline-block;
            
            animation: typewriter 5s steps(30) infinite;
          }

             
        `}
      </style>

<div id='dancers' className="bg-white h-[680px] w-full flex items-center justify-center overflow-hidden">
  <div className="font-bold text-[#AD2F3B] text-[32px] max-[440px]:text-[32px] max-[440px]:mx-8 text-center flex flex-wrap justify-center">
    <span className="typewriter break-words max-[440px]:break-words">
      Opportunities Coming Soon !!
    </span>
  </div>
</div>






      <Footer />
    </>
  );
}

export default Opportunities

